import styled from 'styled-components';

export const CompanyTemplateError = styled.div`
  color: ${({ theme }) => theme.red.a10};
  font-style: italic;
  font-weight: 300;
  font-size: 0.8rem;
  padding: 0 10px;
  text-align: right;
  margin-top: 5px;
`;

export const ButtonMargin = styled.div`
  margin-left: 10px;
`;
